/* eslint-disable no-nested-ternary */
import { PlanActionMode, PlanInterval } from '@aibees/shared/definition';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { useEffect, useState } from 'react';
import { usePlanCardContext } from '../../../context';
import { ActionButtonText } from '../types';

export function usePlanDynamicAction() {
  const [actionMode, setActionMode] = useState<PlanActionMode | null>(
    PlanActionMode.DOWNGRADE_PAID
  );
  const [buttonText, setButtonText] = useState<ActionButtonText>('Downgrade');

  const { data } = useCurrentSubscriptionApi();
  const { selectedPlan } = usePlanCardContext();

  const userCurrntPlan = data?.current?.plan;
  const userNextPlan = data?.next?.plan;

  const nextPlanIsFree =
    selectedPlan?.metadata.is_free === 'true' &&
    userNextPlan?.id === selectedPlan?.id;

  const currentPlanIsFree =
    selectedPlan?.metadata.is_free === 'true' &&
    userCurrntPlan?.id === selectedPlan?.id;

  const selectedCurrentPlan = selectedPlan?.id === userCurrntPlan?.id;

  useEffect(() => {
    const selectedPlanRollover = Number(selectedPlan?.metadata.rollover);
    const currentPlanRollover = Number(selectedPlan?.metadata.rollover);

    const selectedPlanInterval =
      selectedPlan?.interval === PlanInterval.YEAR ? 12 : 1;
    const selectedPlanMonthlyCredit =
      Number(selectedPlan?.metadata.request ?? 0) / selectedPlanInterval;

    const userCurrentPlanInterval =
      userCurrntPlan?.interval === PlanInterval.YEAR ? 12 : 1;
    const userCurrentPlanMonthlyCredit =
      Number(userCurrntPlan?.metadata.request ?? 0) / userCurrentPlanInterval;

    const upgrade =
      selectedPlanMonthlyCredit === userCurrentPlanMonthlyCredit
        ? 0
        : selectedPlanMonthlyCredit > userCurrentPlanMonthlyCredit
        ? 1
        : -1;

    let action = null;
    if (upgrade === 0) {
      if (selectedPlanRollover > currentPlanRollover) {
        action = PlanActionMode.UPGRADE;
      } else {
        action = PlanActionMode.DOWNGRADE_PAID;
      }
    } else {
      action =
        upgrade > 0 ? PlanActionMode.UPGRADE : PlanActionMode.DOWNGRADE_PAID;
    }
    setActionMode(action);
    setButtonText(action === PlanActionMode.UPGRADE ? 'Upgrade' : 'Downgrade');

    if (selectedCurrentPlan) {
      setActionMode(null);
      setButtonText('Selected');
    }

    if (nextPlanIsFree) {
      setActionMode(PlanActionMode.CANCEL_DOWNGRADE);
      setButtonText('Cancel Downgrade');
    }
    if (
      selectedPlan?.metadata.is_free === 'true' &&
      !nextPlanIsFree &&
      !currentPlanIsFree
    ) {
      setActionMode(PlanActionMode.DOWNGRADE_FREE);
      setButtonText('Downgrade to Free');
    }

    if (currentPlanIsFree) {
      setActionMode(null);
      setButtonText('Current Plan');
    }
  }, [data, selectedPlan]);

  return { actionMode, buttonText };
}
